import { WSActions, WSList, WSPanel } from "@wingspanhq/fe-component-library";
import { OnboardingStep } from "../../../../Onboarding/types";
import React from "react";
import { AboutOAI } from "../../../components/customBenefits/OAI/AboutOAI";

export const StepAbout: React.FC<OnboardingStep> = props => {
  return (
    <WSPanel>
      <WSList gap="2XL">
        <AboutOAI />
        <WSActions
          alignment="fill"
          buttons={[
            {
              kind: "Tertiary",
              onClick: props.onBack,
              label: "Back"
            },
            {
              label: "Continue",
              type: "submit",
              onClick: props.onNext
            }
          ]}
        />
      </WSList>
    </WSPanel>
  );
};
